/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:59]
Permissions to update outside the main branch: [false]
*/

import { Button, requiredRule, ValidatedInput } from '@finbeat/react-toolkit';
import { faPlus, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import { LeadgenInfo, LeadgenTarificationRangeInfo } from 'models/api/leadgen';
import { useFormContext } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

const emptyItem: LeadgenTarificationRangeInfo = {
    id: null,
    amount: null,
    from: null,
    to: null,
    isDeleted: false,
};

type LeadgenModalTarificationRangesProps = {
    tarificationParameterId: number;
    disabled: boolean;
};

const LeadgenModalTarificationRanges = (props: LeadgenModalTarificationRangesProps) => {
    const { setValue, getValues, watch } = useFormContext<LeadgenInfo>();

    const addTarificationRanges = () => {
        setValue(`tarificationParameters.${props.tarificationParameterId}.tarificationRanges`, [
            ...getValues().tarificationParameters[props.tarificationParameterId].tarificationRanges,
            emptyItem,
        ]);
    };

    const deleteTarificationRanges = (id: number | null, ids: number) => {
        setValue(
            `tarificationParameters.${props.tarificationParameterId}.tarificationRanges`,
            getValues().tarificationParameters[
                props.tarificationParameterId
            ].tarificationRanges.map((x, i) => (i === ids ? { ...x, isDeleted: true } : x))
        );
    };

    const tarificationRanges = watch(
        `tarificationParameters.${props.tarificationParameterId}.tarificationRanges`
    );

    return (
        <>
            {tarificationRanges && tarificationRanges.length ? (
                tarificationRanges.map((item, ids) => (
                    <Card className="mb-3" key={ids} hidden={item.isDeleted}>
                        <CardHeader className="leadgen-modal__card-header">
                            <>
                                {item.id ? `#${item.id}` : t('BackOfficeNew')}
                                <Button
                                    color="danger"
                                    onClick={() => deleteTarificationRanges(item.id, ids)}
                                    disabled={props.disabled}
                                >
                                    <FontAwesomeIcon icon={faTrashCan} />
                                </Button>
                            </>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col>
                                    <ValidatedInput
                                        name={`tarificationParameters.${props.tarificationParameterId}.tarificationRanges[${ids}].amount`}
                                        label={t('BackOfficeTarificationRangeAmount')}
                                        type="number"
                                        rules={{
                                            required: requiredRule,
                                        }}
                                        disabled={props.disabled}
                                    />
                                </Col>
                                <Col>
                                    <ValidatedInput
                                        name={`tarificationParameters.${props.tarificationParameterId}.tarificationRanges[${ids}].from`}
                                        label={t('BackOfficeTarificationRangeFrom')}
                                        type="number"
                                        rules={{
                                            required: requiredRule,
                                        }}
                                        disabled={props.disabled}
                                    />
                                </Col>
                                <Col>
                                    <ValidatedInput
                                        name={`tarificationParameters.${props.tarificationParameterId}.tarificationRanges[${ids}].to`}
                                        label={t('BackOfficeTarificationRangeTo')}
                                        type="number"
                                        rules={{
                                            required: requiredRule,
                                        }}
                                        disabled={props.disabled}
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                ))
            ) : (
                <></>
            )}
            <Button color="secondary" onClick={addTarificationRanges} disabled={props.disabled}>
                <FontAwesomeIcon icon={faPlus} /> <Trans i18nKey="BackOfficeAdd" />
            </Button>
        </>
    );
};

export default LeadgenModalTarificationRanges;
